/** request id key */
export const REQUEST_ID_KEY = 'P-Request-Id';

/** request language key */
export const REQUEST_LANGUAGE = 'P-Language';

/** the backend error code key */
export const BACKEND_ERROR_CODE = 'BACKEND_ERROR';
